import useInference from "./useInference";
import Category from "../../settings/companyAdministration/Category";
import TitleAndSubTitle from "../../settings/TitleAndSubTitle";
import {DropDownMenuComponent, InputComponent, SwitchComponent} from "../../../../utils/FormComponents";
import React from "react";
import {FaKey, FaRegSave} from "react-icons/fa";
import {LoadingAnimationContainer} from "../../../../utils/loading_animation";
import {ACTION, GENERIC_MODAL_ACTIONS} from "../../../../context/actionTypes";
import InfoMessageNote from "../../settings/messageNote/InfoMessageNote";

export default function Inference() {
    const [
        {configuration, modifiedKeys, isModified, availableModels},
        {handleToggleQuestions, handleToggleDocumentsUpload, handleCompletionsModelChange, handleTeiModelChange, handleNumberChange, saveConfiguration, toggleMe, dispatch},
    ] = useInference();

    return (
        <main className="flex flex-col gap-2">
            <TitleAndSubTitle h1="Gestion API Inférence"/>

            <Category title="Gérez la connexion avec l'API d'inférence">
                {configuration === null ? <LoadingAnimationContainer/> : (
                    <div className="flex flex-col gap-6 items-start fadeIn">
                        <div className="flex items-start gap-8 flex-wrap">
                            <SwitchComponent
                                label="Questions au Chatbot :"
                                name="questions_enabled"
                                checked={configuration.questions_enabled}
                                onChange={handleToggleQuestions}
                                checkedLabel="Activées"
                                uncheckedLabel="Désactivées"
                                className="col-span-2 xl:col-span-1"
                            />
                            <SwitchComponent
                                label="Ajout de documents :"
                                name="documents_upload_enabled"
                                checked={configuration.documents_upload_enabled}
                                onChange={handleToggleDocumentsUpload}
                                checkedLabel="Activés"
                                uncheckedLabel="Désactivés"
                                className="col-span-2 xl:col-span-1"
                            />
                        </div>
                    </div>
                )}
            </Category>

            <Category title="Choisir le modèle à utiliser">
                {(availableModels.length === 0 || configuration === null) ? <LoadingAnimationContainer/> : (<>
                    <div className="flex gap-8 items-start flex-wrap">
                        <DropDownMenuComponent
                            label="Modèle de completions :"
                            name="completions_model"
                            items={availableModels}
                            labelField="id"
                            onItemSelected={handleCompletionsModelChange}  // Handle modele selection
                            currentItem={availableModels.find((model) => model.id === configuration.completions_model)}
                            className="fadeIn"
                            showDefaultOption={false}
                        />
                        <DropDownMenuComponent
                            label="Modèle de TEI :"
                            name="tei_model"
                            items={availableModels}
                            labelField="id"
                            onItemSelected={handleTeiModelChange}  // Handle modele selection
                            currentItem={availableModels.find((model) => model.id === configuration.tei_model)}
                            className="fadeIn"
                            showDefaultOption={false}
                        />
                    </div>
                    <InfoMessageNote display={<>
                        Attention, tous les modèles ne sont pas compatibles avec toutes les tâches, veuillez vérifier sur la <a
                        className="text-figmaColors-ActiveDarkBlueInteraction font-semibold"
                        href="https://www.scaleway.com/en/docs/generative-apis/reference-content/supported-models/"
                        target="_blank"
                    >documentation de scaleway</a> !
                    </>}/>
                </>)}
            </Category>
            <Category title="Modifier les ratelimits">
                {configuration === null ? <LoadingAnimationContainer/> : (<>
                        <p className="text-xs mb-6">Entrez le nombre de requêtes autorisées par minute pour chaque type d'inférence</p>
                        <div className="flex gap-8 items-start flex-wrap fadeIn">
                            <InputComponent
                                label="API de completions :"
                                name="completions_request_limit"
                                value={configuration.completions_request_limit}
                                onChange={handleNumberChange}
                                type="number"
                                min={1}
                            />
                            <InputComponent
                                label="API de TEI :"
                                name="tei_request_limit"
                                value={configuration.tei_request_limit}
                                onChange={handleNumberChange}
                                type="number"
                                min={1}
                            />
                        </div>
                    </>
                )}
            </Category>

            <button
                className="btn-transition mt-3 ml-4 mb-6 w-fit"
                onClick={() => {
                    dispatch({
                        type: ACTION.SET_GENERIC_MODAL,
                        payload: {
                            action: GENERIC_MODAL_ACTIONS.CHANGE_INFERENCE_SETTINGS,
                            props: {modifiedKeys, toggleMe, saveConfiguration,dispatch},
                        },
                    });
                }}
                disabled={!isModified}
            >
                <FaRegSave className="h-5 w-5"/>
                <div>Enregistrer</div>
            </button>

            <Category title="Modifier la clé d'API de Scaleway">
                <p>Il est recommandé de modifier cette clée régulièrement.</p>

                <button
                    className="btn-transition mt-3 w-fit"
                    onClick={() => {
                        dispatch({
                            type: ACTION.SET_GENERIC_MODAL,
                            payload: {
                                action: GENERIC_MODAL_ACTIONS.CHANGE_INFERENCE_API_KEY,
                                props: null,
                            },
                        });
                    }}
                >
                    <FaKey className="h-5 w-5"/>
                    <div>Modifier la clé d'API</div>
                </button>
            </Category>
        </main>
    );
}
